import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = {
  key: 0,
  class: "bg-gradient-to-t from-white absolute bottom-0 w-full h-50"
}

import { computed, ref } from 'vue';
import ExpandButton from '@/shared/navigation/ExpandButton.vue';
import { useElementBounding } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'TruncateText',
  props: {
    readMoreLabel: null,
    readLessLabel: null,
    teaserHeight: { default: 160 },
    buttonClass: { default: 'mb-x5 md:mb-x6' },
    showGradient: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { readMoreLabel: string, readLessLabel: string, teaserHeight: number, buttonClass: string, showGradient: boolean }



const showFullText = ref(false);
const element = ref(null);
const { height: fullHeight } = useElementBounding(element);

const hasCalculatedHeight = computed(() => fullHeight.value > 0);
const truncateText = computed(() => fullHeight.value > props.teaserHeight);
const teaseText = computed(() => !hasCalculatedHeight.value || (truncateText.value && !showFullText.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "overflow-hidden relative transition-height duration-300 ease-in-out",
      style: _normalizeStyle({'height': `${_unref(teaseText) ? __props.teaserHeight : _unref(fullHeight) + 10}px`})
    }, [
      _createElementVNode("span", {
        id: "truncatableContent",
        ref_key: "element",
        ref: element,
        "aria-hidden": !showFullText.value
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1),
      (_unref(teaseText) && __props.showGradient)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", {
      class: _normalizeClass([__props.buttonClass, {'mt-x1': _unref(teaseText)}])
    }, [
      (_unref(truncateText))
        ? (_openBlock(), _createBlock(ExpandButton, {
            key: 0,
            "aria-expanded": showFullText.value,
            "aria-controls": "truncatableContent",
            "collapse-label": __props.readLessLabel,
            "expand-label": __props.readMoreLabel,
            onClick: _cache[0] || (_cache[0] = (isToggled) => showFullText.value = isToggled)
          }, null, 8, ["aria-expanded", "collapse-label", "expand-label"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})